/* ReferralCandy supplies the discount. This module only manages its marked cart gift. */
(function (host, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else if (!host.PtvReferralGift && host.PtvReferralGiftConfig) host.PtvReferralGift = factory(host.PtvReferralGiftConfig, host);
})(typeof window !== 'undefined' ? window : this, function (config, env) {
  'use strict';
  const cfg = Object.assign({ threshold: 8000, currency: 'EUR', ttlMs: 86400000, welcomeEnabled: true, progressEnabled: true, requestTimeoutMs: 6500, verifyDelaysMs: [250, 750, 1500] }, config);
  const validId = value => /^[1-9][0-9]*$/.test(String(value)) && Number.isSafeInteger(Number(value));
  const validCampaign = value => typeof value === 'string' && /^[a-z0-9_.-]{1,200}$/i.test(value);
  const configValid = validCampaign(cfg.campaign) && validId(cfg.giftProductId) && validId(cfg.giftVariantId) && Number.isSafeInteger(cfg.threshold) && cfg.threshold >= 0 && Number.isSafeInteger(cfg.ttlMs) && cfg.ttlMs > 0 && cfg.currency === 'EUR';
  // Invalid editor values disable new gifts, while cleanup and ordinary carts remain available.
  cfg.enabled = cfg.enabled !== false && configValid;
  const configSignature = JSON.stringify([cfg.campaign, String(cfg.giftProductId), String(cfg.giftVariantId)]);
  const legacyProductId = '15439968469371', legacyVariantId = '56469212430715', legacyCampaign = 'referralcandy_127283';
  const storageKey = 'ptv-referral-gift-v1';
  // Older versions recorded a view. Only an explicit close dismisses this notice.
  const welcomeStorageKey = 'ptv-referral-welcome-dismissed-v1';
  const excluded = new Set((cfg.excludedVariantIds || []).map(String));
  const doc = env.document;
  const now = () => (env.Date || Date).now();
  const sleep = ms => new Promise(resolve => env.setTimeout(resolve, ms));
  const root = () => ((env.Shopify && env.Shopify.routes && env.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const validAic = value => typeof value === 'string' && /^[a-z0-9]{4,64}$/i.test(value);
  const marker = item => !!(item && item.properties && validCampaign(item.properties._ptv_referral_gift) && typeof item.properties._ptv_referral_instance === 'string' && item.properties._ptv_referral_instance.length > 7);
  const isGift = item => !!item && (String(item.product_id) === String(cfg.giftProductId) || String(item.variant_id || item.id) === String(cfg.giftVariantId));
  const currentIds = item => !!item && validId(cfg.giftProductId) && validId(cfg.giftVariantId) && String(item.product_id) === String(cfg.giftProductId) && String(item.variant_id || item.id) === String(cfg.giftVariantId);
  const isManaged = item => {
    if (!marker(item)) return false;
    const productId = String(item.product_id), variantId = String(item.variant_id || item.id), properties = item.properties;
    const legacy = properties._ptv_referral_gift === legacyCampaign && productId === legacyProductId && variantId === legacyVariantId;
    const stamped = validId(properties._ptv_referral_product) && validId(properties._ptv_referral_variant) && String(properties._ptv_referral_product) === productId && String(properties._ptv_referral_variant) === variantId;
    return currentIds(item) || legacy || stamped;
  };
  const isCurrentGift = item => isManaged(item) && currentIds(item) && item.properties._ptv_referral_gift === cfg.campaign;
  const rows = cart => Array.isArray(cart && cart.items) ? cart.items : [];
  const shapeUnknown = cart => rows(cart).some(item => item.parent_relationship || item.item_group || item.line_item_group || (marker(item) && !isManaged(item)));
  function subtotal(cart) {
    // Top-level parent prices already include their bundle components. Never sum nested children.
    let total = rows(cart).reduce((sum, item) => {
      if (isGift(item) || marker(item) || excluded.has(String(item.variant_id || item.id))) return sum;
      return sum + (Number.isFinite(item.final_line_price) && item.final_line_price > 0 ? item.final_line_price : 0);
    }, 0);
    // Conservative net-cart guard; Shopify separately decides its BXGY/tax eligibility.
    (cart.cart_level_discount_applications || []).forEach(discount => {
      if (Number.isFinite(discount.total_allocated_amount) && discount.total_allocated_amount > 0) total -= discount.total_allocated_amount;
    });
    return Math.max(0, total);
  }
  function free(item) {
    if (!item || item.quantity !== 1 || item.final_line_price !== 0) return false;
    return (item.line_level_discount_allocations || []).concat(item.discounts || []).some(discount => Number(discount.amount) > 0);
  }
  function fingerprint(cart) {
    return JSON.stringify({ currency: cart.currency, items: rows(cart).filter(item => !isManaged(item)).map(item => [String(item.variant_id || item.id), item.quantity, item.final_line_price, item.properties || {}, item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id]).sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))), codes: (cart.discount_codes || []).map(code => String(code.code || '')).sort(), discounts: (cart.cart_level_discount_applications || []).map(discount => [discount.title, discount.total_allocated_amount]) });
  }
  let context = null;
  let welcomeInstance = null;
  let welcomeAttempted = false;
  let welcomeDismissed = false;
  let tail = Promise.resolve();
  let timer = null;
  let workQueued = false;
  let dirty = false;
  let lastCart = null;
  let ownVersion = 0;
  let requestedMutationVersion = 0;
  let lastCartActionAt = 0;
  let lastContextActive;
  let callbackDepth = 0;
  let updatedHook;
  let loadedHook;
  const discountHooks = {};
  let discountCallbackDepth = 0;
  const completedDiscountKinds = new Set();
  let discountAction = null;
  let discountFailed = false;
  let publishNextCart = false;
  let appRefreshPending = false;
  let externalAction = null;
  let externalFailed = false;
  const appResponses = new WeakSet();
  let progressOperations = 0;
  let progressFault = false;
  let progressSignature;
  let progressExpiryTimer = null;
  let progressExpiresAt = null;
  let progressConfirmation = null;
  function progressStamp(info) {
    return JSON.stringify([context.instance, context.createdAt, lastCart.token, requestedMutationVersion, ownVersion, info.fingerprint]);
  }
  function progressPending() {
    return timer !== null || workQueued || progressOperations || externalAction || discountAction || context.attempting;
  }
  function getProgress() {
    if (cfg.progressEnabled === false || !hasContext() || (lastCart && lastCart.currency !== cfg.currency)) return null;
    const info = lastCart && inspect(lastCart);
    // Eligibility is strictly over the threshold; EUR 80.00 still needs EUR 0.01.
    const target = cfg.threshold + 1;
    const amount = info ? info.subtotal : 0;
    const result = { status: 'checking', subtotal: amount, target: target, remaining: Math.max(0, target - amount), percent: Math.min(100, Math.max(0, amount / target * 100)), expiresAt: context.createdAt + cfg.ttlMs };
    const added = info && context.token && lastCart.token === context.token && info.eligible && context.giftPresent && info.owned.length === 1 && isCurrentGift(info.owned[0]) && info.owned[0].properties._ptv_referral_instance === context.instance && free(info.owned[0]);
    const remaining = info && context.token && lastCart.token === context.token && !info.owned.length && !info.manual && !info.unknown && context.blocked !== info.fingerprint && context.attempted !== info.fingerprint && amount < target;
    // A no-op background read must not blink a confirmed gift or remaining amount.
    // Mutations, changed cart/context and failed checks invalidate this stamp;
    // a newly added gift still waits for reconciliation to finish.
    const keepConfirmed = (added || remaining) && !externalAction && !discountAction && !context.attempting && progressConfirmation === progressStamp(info);
    if (progressFault || externalFailed || discountFailed || (info && (info.manual || info.unknown || context.blocked === info.fingerprint))) result.status = 'unavailable';
    else if (!info || progressPending() && !keepConfirmed) result.status = 'checking';
    else if (added) result.status = 'added';
    else if (info.owned.length || context.attempted === info.fingerprint) result.status = 'unavailable';
    else if (amount < target) result.status = 'remaining';
    return result;
  }
  function publishProgress() {
    const state = getProgress();
    if (state && (state.status === 'added' || state.status === 'remaining' && context.token && lastCart.token === context.token) && !progressPending()) progressConfirmation = progressStamp(inspect(lastCart));
    else if (!state || state.status === 'unavailable') progressConfirmation = null;
    const expiresAt = state && state.expiresAt;
    if (expiresAt !== progressExpiresAt) {
      env.clearTimeout(progressExpiryTimer);
      progressExpiresAt = expiresAt;
      progressExpiryTimer = expiresAt ? env.setTimeout(function () { progressExpiresAt = null; publishProgress(); }, Math.min(2147483647, Math.max(0, expiresAt - now()))) : null;
    }
    const signature = JSON.stringify(state);
    if (signature === progressSignature) return;
    progressSignature = signature;
    // The cart UI consumes this read-only event; never refresh AMP or rebuild a cart here.
    if (doc && env.CustomEvent) doc.dispatchEvent(new env.CustomEvent('ptv:referral-progress', { detail: { state: state } }));
  }
  function validContext(value) {
    // Existing DOPE sessions can upgrade once; a changed gift requires a new explicit referral visit.
    const signatureMatches = value && (value.configSignature === configSignature || (!value.configSignature && cfg.campaign === legacyCampaign && String(cfg.giftProductId) === legacyProductId && String(cfg.giftVariantId) === legacyVariantId));
    return value && signatureMatches && value.campaign === cfg.campaign && validAic(value.aic) && Number.isFinite(value.createdAt) && typeof value.instance === 'string';
  }
  function readStored() {
    try { if (env.localStorage) return JSON.parse(env.localStorage.getItem(storageKey) || 'null'); } catch (_) {}
    try { return JSON.parse(env.sessionStorage.getItem(storageKey) || 'null'); } catch (_) { return context; }
  }
  function readShared() {
    const stored = readStored();
    if (validContext(stored)) context = stored;
    else if (stored === null || stored && !validContext(stored)) context = null;
  }
  function hasContext() { return !!(context && context.active && !context.suppressed && context.createdAt <= now() && now() - context.createdAt < cfg.ttlMs && cfg.enabled !== false); }
  function save(inbound) {
    const stored = readStored();
    // Another tab may receive a newer referral while an earlier cart request is in flight.
    if (!inbound && validContext(stored) && context && stored.instance !== context.instance && (stored.generation || 0) >= (context.generation || 0)) context = stored;
    if (context) context.configSignature = configSignature;
    const encoded = JSON.stringify(context);
    try { if (env.localStorage && env.localStorage.getItem(storageKey) !== encoded) env.localStorage.setItem(storageKey, encoded); } catch (_) {}
    try { if (env.sessionStorage.getItem(storageKey) !== encoded) env.sessionStorage.setItem(storageKey, encoded); } catch (_) { /* In-memory fallback cannot coordinate separate tabs. */ }
    const active = hasContext();
    if (active !== lastContextActive) {
      lastContextActive = active;
      if (doc && env.CustomEvent) doc.dispatchEvent(new env.CustomEvent('ptv:referral-context', { detail: { active: active } }));
    }
    publishProgress();
  }
  readShared();
  function nonce() {
    if (env.crypto && env.crypto.randomUUID) return env.crypto.randomUUID();
    return now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }
  // Capture synchronously: the native theme can navigate immediately after adding a product.
  try {
    const params = new URL(env.location.href).searchParams;
    if (params.has('utm_campaign')) {
      const aic = params.get('aic');
      if (cfg.enabled && params.get('utm_campaign') === cfg.campaign && validAic(aic)) {
        const navigation = env.performance && env.performance.getEntriesByType && env.performance.getEntriesByType('navigation')[0];
        const inactive = context && (!context.active || context.createdAt > now() || now() - context.createdAt >= cfg.ttlMs);
        // A new explicit visit can begin a new session; refresh/history cannot extend its TTL.
        if (!context || context.aic !== aic || (inactive && navigation && navigation.type === 'navigate')) context = { campaign: cfg.campaign, configSignature: configSignature, aic: aic, createdAt: now(), generation: ((context && context.generation) || 0) + 1, instance: nonce(), token: null, active: true, seenItems: false, giftPresent: false, suppressed: false };
        if (hasContext()) welcomeInstance = context.instance;
      } else if (context) context.active = false;
      save(true);
    }
  } catch (_) {}
  // Keep an unclosed notice while browsing without the referral URL parameters.
  if (hasContext()) welcomeInstance = context.instance;
  function syncContext(cart) {
    readShared();
    if (!context) return false;
    if (now() - context.createdAt >= cfg.ttlMs || context.createdAt > now() || cfg.enabled === false) context.active = false;
    const token = typeof cart.token === 'string' ? cart.token : '';
    if (!token) context.active = false;
    else if (!context.token) context.token = token;
    else if (context.token !== token) context.active = false;
    if (!rows(cart).length && context.seenItems) context.active = false;
    if (rows(cart).length) context.seenItems = true;
    save();
    return !!context.active;
  }
  function welcomeWasDismissed() {
    if (welcomeDismissed) return true;
    if (!welcomeInstance) return false;
    for (const name of ['sessionStorage', 'localStorage']) {
      try {
        if (env[name] && env[name].getItem(welcomeStorageKey) === welcomeInstance) {
          welcomeDismissed = true;
          return true;
        }
      } catch (_) {}
    }
    return false;
  }
  function positionStatus() {
    const status = doc && doc.getElementById('ptv-referral-status');
    if (!status || !doc.body) return;
    const welcome = doc.getElementById('ptv-referral-welcome');
    const inline = welcome && !welcome.hidden;
    const parent = inline ? welcome : doc.body;
    // Real cart errors stay readable alongside the welcome, never on top of it.
    if (status.parentElement !== parent) parent.appendChild(status);
    status.style.cssText = inline
      ? 'position:static;margin:12px 0 0;padding:12px;background:#161616;color:#fff;border:1px solid #666;border-radius:8px;font:inherit;'
      : 'position:fixed;bottom:20px;left:20px;right:20px;z-index:2147483000;max-width:620px;margin:auto;padding:14px 18px;background:#161616;color:#fff;border:1px solid #666;border-radius:8px;font:inherit;';
  }
  function hideWelcome() {
    const region = doc && doc.getElementById('ptv-referral-welcome');
    if (region) region.hidden = true;
    positionStatus();
  }
  function dismissWelcome() {
    welcomeDismissed = true;
    for (const name of ['sessionStorage', 'localStorage']) {
      try { if (env[name]) env[name].setItem(welcomeStorageKey, welcomeInstance); } catch (_) { /* Closing still works without storage. */ }
    }
    hideWelcome();
  }
  function showWelcome() {
    if (welcomeWasDismissed()) { hideWelcome(); return; }
    if (!doc || !doc.body || cfg.welcomeEnabled === false || welcomeAttempted || !welcomeInstance || !hasContext() || context.instance !== welcomeInstance) return;
    const region = doc.getElementById('ptv-referral-welcome');
    if (!region) return;
    welcomeAttempted = true;
    const close = region.querySelector('[data-ptv-referral-welcome-close]');
    if (close) close.addEventListener('click', dismissWelcome);
    region.hidden = false;
    positionStatus();
  }
  function message(kind) {
    progressFault = kind === 'unsafe' || kind === 'unavailable';
    publishProgress();
    if (!doc || !doc.body) return;
    // Cart verification runs silently, including after the welcome is dismissed.
    // Keep genuine error messages; checking is only an internal progress state.
    if (kind === 'checking') kind = '';
    let region = doc.getElementById('ptv-referral-status');
    if (!region) {
      region = doc.createElement('div');
      region.id = 'ptv-referral-status';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      doc.body.appendChild(region);
    }
    region.textContent = (cfg.messages || {})[kind] || '';
    region.hidden = !region.textContent;
    positionStatus();
  }
  function enqueue(work) {
    progressOperations += 1;
    publishProgress();
    const operation = tail.catch(function () {}).then(function () {
      if (env.navigator && env.navigator.locks && env.navigator.locks.request && env.AbortController) {
        const controller = new env.AbortController();
        const timeout = env.setTimeout(function () { controller.abort(); }, cfg.requestTimeoutMs);
        return env.navigator.locks.request('ptv-referral-' + cfg.campaign, { signal: controller.signal }, function () {
          env.clearTimeout(timeout); return work();
        }).finally(function () { env.clearTimeout(timeout); });
      }
      return work();
    });
    const observed = operation.catch(function (error) { progressFault = true; throw error; }).finally(function () { progressOperations -= 1; publishProgress(); });
    tail = observed.catch(function () {});
    return observed;
  }
  async function request(path, body) {
    const controller = env.AbortController ? new env.AbortController() : null;
    let timeout;
    const expiry = new Promise((_, reject) => {
      timeout = env.setTimeout(function () {
        if (controller) controller.abort();
        const error = new Error('Cart request timed out'); error.uncertain = body !== undefined; reject(error);
      }, cfg.requestTimeoutMs);
    });
    try {
      return await Promise.race([expiry, (async function () {
        const options = { method: body === undefined ? 'GET' : 'POST', headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' };
        if (controller) options.signal = controller.signal;
        if (body !== undefined) { options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
        const response = await env.fetch(root() + path, options);
        if (!response.ok) { const error = new Error('Cart request failed: ' + response.status); error.status = response.status; error.uncertain = body !== undefined && response.status >= 500; throw error; }
        return await response.json();
      })()]);
    } finally { env.clearTimeout(timeout); }
  }
  async function get() {
    try {
      const cart = await request('cart.js');
      if (!cart || !Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) throw new Error('Invalid cart response');
      lastCart = cart;
      progressFault = false;
      publishProgress();
      return cart;
    } catch (error) { progressFault = true; publishProgress(); throw error; }
  }
  function emit(cart) {
    if (doc && env.CustomEvent) doc.dispatchEvent(new env.CustomEvent('ptv:referral-cart-changed', { detail: { cart: cart } }));
  }
  function refreshApp(cart) {
    emit(cart);
    connectApps();
    if (appRefreshPending || typeof env.SLIDECART_UPDATE !== 'function') return;
    appRefreshPending = true;
    const version = ownVersion;
    const release = env.setTimeout(function () { appRefreshPending = false; }, 6000);
    try {
      env.SLIDECART_UPDATE(function (value) {
        if (value && typeof value === 'object') appResponses.add(value);
        env.clearTimeout(release);
        appRefreshPending = false;
        // Do not publish an AMP response which predates another managed mutation.
        if (version !== ownVersion) { schedule(); return; }
        if (value && Array.isArray(value.items)) emit(value);
      });
    } catch (_) { env.clearTimeout(release); appRefreshPending = false; }
  }
  async function write(path, body) { ownVersion += 1; return request(path, body); }
  async function removeOwned(predicate) {
    // Refresh keys after every operation; discounts can change all line keys.
    for (let attempt = 0; attempt < 8; attempt += 1) {
      const cart = await get();
      const item = rows(cart).find(row => isManaged(row) && (!predicate || predicate(row, cart)));
      if (!item) { if (context && !rows(cart).some(isManaged)) { context.giftPresent = false; save(); } return cart; }
      // A marked flattened child is not a safely removable bundle parent.
      if (item.parent_relationship || item.item_group || item.line_item_group) throw new Error('Managed gift has an unknown relationship');
      if (!item.key) throw new Error('Managed gift has no current line key');
      await write('cart/change.js', { id: item.key, quantity: 0 });
    }
    throw new Error('Could not remove all managed gifts');
  }
  async function clean(predicate) {
    const cart = await removeOwned(predicate);
    refreshApp(cart);
    return cart;
  }
  async function sessionChanged(instance) {
    readShared();
    if (context && context.instance === instance) return false;
    await clean(item => item.properties._ptv_referral_instance === instance);
    schedule(); message('checking'); return true;
  }
  function eligible(cart) { return cart.currency === cfg.currency && !shapeUnknown(cart) && subtotal(cart) > cfg.threshold; }
  function inspect(cart) { return { subtotal: subtotal(cart), eligible: eligible(cart), fingerprint: fingerprint(cart), owned: rows(cart).filter(isManaged), manual: rows(cart).some(item => isGift(item) && !isManaged(item)), unknown: shapeUnknown(cart) }; }
  async function verifyGift(cart) {
    for (let attempt = 0; attempt <= cfg.verifyDelaysMs.length; attempt += 1) {
      const info = inspect(cart);
      if (!syncContext(cart) || !info.eligible || info.manual || info.unknown) return null;
      if (info.owned.length === 1 && isCurrentGift(info.owned[0]) && info.owned[0].properties._ptv_referral_instance === context.instance && free(info.owned[0])) return cart;
      if (!info.owned.length) return null;
      if (attempt === cfg.verifyDelaysMs.length) break;
      await sleep(cfg.verifyDelaysMs[attempt]);
      cart = await get();
    }
    return null;
  }
  async function reconcile() {
    if (discountAction && !(await discountAction.promise)) { message('unsafe'); return false; }
    if (externalAction && !(await externalAction.promise)) { message('unsafe'); return false; }
    if (externalFailed || discountFailed) { message('unsafe'); return false; }
    readShared();
    let cart = await get();
    if (publishNextCart) { publishNextCart = false; emit(cart); }
    let info = inspect(cart);
    if (info.unknown && rows(cart).some(item => marker(item) && !isManaged(item))) { message('unsafe'); return false; }
    if (info.owned.some(item => !isCurrentGift(item))) {
      // Remove only recognised automation-owned parents from previous settings.
      // Unknown flattened bundle relationships still require a fresh safe cart.
      if (info.owned.some(item => !isCurrentGift(item) && (item.parent_relationship || item.item_group || item.line_item_group))) { message('unsafe'); return false; }
      cart = await clean(item => !isCurrentGift(item)); info = inspect(cart);
    }
    const active = syncContext(cart);
    const instance = context && context.instance;
    if (context && context.giftPresent && !info.owned.length && !context.attempting) { context.suppressed = true; context.giftPresent = false; save(); }
    if (info.owned.length && (!active || !info.eligible || info.manual || info.owned.some(item => item.properties._ptv_referral_instance !== context.instance))) {
      cart = await clean(); info = inspect(cart);
    }
    if (!active || !info.eligible || info.manual || info.unknown) { message(''); return true; }
    if (info.owned.length > 1) {
      const keepInstance = info.owned[0].properties._ptv_referral_instance;
      cart = await clean((item, snapshot) => {
        const owned = rows(snapshot).filter(isManaged);
        return owned.length > 1 && item === owned[owned.length - 1];
      });
      info = inspect(cart);
      if (!info.owned.length || info.owned[0].properties._ptv_referral_instance !== keepInstance) throw new Error('Gift changed during reconciliation');
    }
    if (info.owned.length && info.owned[0].quantity !== 1) {
      await write('cart/change.js', { id: info.owned[0].key, quantity: 1 });
      cart = await get(); info = inspect(cart); refreshApp(cart);
    }
    if (info.owned.length) {
      context.giftPresent = true; context.attempting = false; save();
      const verified = await verifyGift(cart);
      if (await sessionChanged(instance)) return false;
      if (verified) { delete context.attempted; save(); message(''); return true; }
      context.blocked = fingerprint(await get()); save();
      await clean(); message('unavailable'); return true;
    }
    const signature = fingerprint(cart);
    if (context.suppressed || context.blocked === signature || context.attempted === signature) { message(''); return true; }
    context.attempted = signature;
    context.attempting = true;
    save();
    message('checking');
    try {
      await write('cart/add.js', { items: [{ id: cfg.giftVariantId, quantity: 1, properties: { _ptv_referral_gift: cfg.campaign, _ptv_referral_instance: context.instance, _ptv_referral_product: String(cfg.giftProductId), _ptv_referral_variant: String(cfg.giftVariantId) } }] });
      cart = await get();
      if (await sessionChanged(instance)) return false;
      context.giftPresent = rows(cart).some(isManaged); save();
      const verified = await verifyGift(cart);
      if (await sessionChanged(instance)) return false;
      if (verified) { context.attempting = false; delete context.attempted; save(); refreshApp(verified); message(''); return true; }
      context.blocked = fingerprint(cart); save();
      await clean();
    } catch (error) {
      // A timed-out POST can have succeeded server-side. Never retry the add;
      // make bounded fresh reads and clean up only this automation's marked parent.
      if (await sessionChanged(instance)) return false;
      context.blocked = signature; save();
      if (!error.status || error.uncertain) {
        for (const delay of cfg.verifyDelaysMs) { await sleep(delay); await clean(); }
      } else await clean();
    }
    context.attempting = false; context.giftPresent = false; save();
    message('unavailable'); return true;
  }
  function schedule(delay) {
    if (workQueued) { dirty = true; publishProgress(); return; }
    env.clearTimeout(timer);
    timer = env.setTimeout(function () {
      timer = null; workQueued = true;
      enqueue(reconcile).catch(function () { message('unsafe'); }).finally(function () {
        workQueued = false;
        if (dirty) { dirty = false; schedule(); }
        publishProgress();
      });
    }, delay === 0 ? 0 : 80);
    publishProgress();
  }
  function groupQuantity(cart, token) {
    return rows(cart).reduce((sum, item) => sum + (identity(item) === token ? Number(item.quantity) || 0 : 0), 0);
  }
  function acknowledgeExternal(cart) {
    if (!externalAction) return;
    if (!externalAction.unknown && Array.from(externalAction.intents.values()).every(intent => groupQuantity(cart, intent.identity) === intent.quantity)) {
      env.clearTimeout(externalAction.timer); externalAction.resolve(true); externalAction = null; externalFailed = false;
    }
  }
  function trackDiscount(kind) {
    lastCartActionAt = now();
    requestedMutationVersion += 1;
    if (!discountAction) {
      const action = { pending: { applied: 0, removed: 0 } };
      action.promise = new Promise(resolve => { action.resolve = resolve; });
      action.timer = env.setTimeout(function () { if (discountAction === action) { discountFailed = true; action.resolve(false); publishProgress(); } }, cfg.requestTimeoutMs);
      discountAction = action;
    }
    discountAction.pending[kind] += 1;
    publishProgress();
  }
  function completeDiscount(kind) {
    requestedMutationVersion += 1;
    if (kind === 'applied') {
      readShared();
      if (context) { delete context.blocked; delete context.attempted; save(); }
    }
    if (discountAction) {
      discountAction.pending[kind] = Math.max(0, discountAction.pending[kind] - 1);
      if (!discountAction.pending.applied && !discountAction.pending.removed) {
        env.clearTimeout(discountAction.timer); discountAction.resolve(true); discountAction = null; discountFailed = false;
      }
    }
    // REMOVED supplies the previous codes, not a cart. COUPON_APPLIED follows
    // AMP's fresh GET; use our own fresh read for both so keys/prices are current.
    publishNextCart = true;
    schedule(0);
  }
  function connectApps() {
    if (!updatedHook || env.SLIDECART_UPDATED !== updatedHook) {
      const previous = env.SLIDECART_UPDATED;
      let invoking = false;
      updatedHook = function (cart) {
        if (invoking) return;
        invoking = true;
        callbackDepth += 1;
        try { if (typeof previous === 'function') return previous.apply(this, arguments); }
        finally {
          invoking = false;
          callbackDepth -= 1;
          if (!callbackDepth && !(cart && appResponses.has(cart))) {
            if (cart && Array.isArray(cart.items)) {
              if (!lastCart || fingerprint(lastCart) !== fingerprint(cart)) requestedMutationVersion += 1;
              lastCart = cart;
              acknowledgeExternal(cart);
              emit(cart);
            }
            schedule();
          }
        }
      };
      env.SLIDECART_UPDATED = updatedHook;
    }
    if (!loadedHook || env.SLIDECART_LOADED !== loadedHook) {
      const previous = env.SLIDECART_LOADED;
      loadedHook = function () { try { if (typeof previous === 'function') return previous.apply(this, arguments); } finally { connectApps(); schedule(); } };
      env.SLIDECART_LOADED = loadedHook;
    }
    ['SLIDECART_DISCOUNT_REMOVED', 'SLIDECART_COUPON_APPLIED', 'SLIDECART_DISCOUNT_APPLIED'].forEach(function (name) {
      if (discountHooks[name] && env[name] === discountHooks[name]) return;
      const previous = env[name];
      let invoking = false;
      const hook = function () {
        if (invoking) return;
        invoking = true;
        discountCallbackDepth += 1;
        try { if (typeof previous === 'function') return previous.apply(this, arguments); }
        finally {
          invoking = false;
          discountCallbackDepth -= 1;
          completedDiscountKinds.add(name === 'SLIDECART_DISCOUNT_REMOVED' ? 'removed' : 'applied');
          if (!discountCallbackDepth) {
            completedDiscountKinds.forEach(completeDiscount);
            completedDiscountKinds.clear();
          }
        }
      };
      discountHooks[name] = hook;
      env[name] = hook;
    });
  }
  async function beforeCheckout() {
    env.clearTimeout(timer); timer = null;
    try {
      for (let pass = 0; pass < 3; pass += 1) {
        const version = requestedMutationVersion;
        const safe = await enqueue(async function () {
          // The layout flushes its own inputs. AMP owns +/- and remove POSTs;
          // wait for its documented update acknowledgement instead of a fixed delay.
          if (externalAction && !(await externalAction.promise)) { message('unsafe'); return false; }
          if (externalFailed || discountFailed) { message('unsafe'); return false; }
          return await reconcile();
        });
        if (!safe) return false;
        await tail;
        if (version === requestedMutationVersion) return true;
      }
      message('unsafe'); return false;
    } catch (_) { message('unsafe'); return false; }
  }
  function change(key, quantity) {
    requestedMutationVersion += 1;
    return enqueue(async function () {
      const cart = await get();
      if (!rows(cart).some(item => String(item.key) === String(key))) throw new Error('Cart line changed; refresh before changing quantity');
      await write('cart/change.js', { id: key, quantity: quantity });
      const updated = await get(); refreshApp(updated); schedule(); return updated;
    });
  }
  function identity(item) {
    return JSON.stringify([String(item.variant_id || item.id), Object.keys(item.properties || {}).sort().map(key => [key, item.properties[key]]), item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id || null]);
  }
  function trackExternal(button) {
    if (button.disabled || (button.getAttribute && button.getAttribute('aria-disabled') === 'true')) return;
    readShared();
    lastCartActionAt = now();
    requestedMutationVersion += 1;
    // Ordinary carts keep AMP's native behavior, including stock-limit errors.
    if (!hasContext() && !rows(lastCart).some(marker)) return;
    if (!externalAction) {
      const action = { intents: new Map(), lines: new Map(), unknown: false };
      action.promise = new Promise(resolve => { action.resolve = resolve; });
      action.timer = env.setTimeout(function () { if (externalAction === action) { externalFailed = true; action.resolve(false); publishProgress(); } }, cfg.requestTimeoutMs);
      externalAction = action;
      publishProgress();
    }
    const row = button.closest && button.closest('.item');
    const key = row && row.getAttribute('data-line-item-key');
    const variantId = row && row.getAttribute('data-variant-id');
    const variants = rows(lastCart).filter(item => String(item.variant_id || item.id) === String(variantId));
    const pendingLine = externalAction.lines.get(String(key));
    const item = rows(lastCart).find(item => String(item.key) === String(key)) || (pendingLine && pendingLine.item) || (variants.length === 1 ? variants[0] : null);
    const label = (button.getAttribute && button.getAttribute('aria-label') || '').toLowerCase();
    const remove = label.startsWith('remove ') || button.matches && button.matches('button.remove, .remove');
    const selector = button.closest && button.closest('.quantity-selector');
    const controls = selector && selector.querySelectorAll && selector.querySelectorAll('button');
    const delta = controls && controls.length === 2 ? (button === controls[0] ? -1 : button === controls[1] ? 1 : 0) : label.includes('increase quantity') ? 1 : label.includes('decrease quantity') ? -1 : 0;
    if (!item || (!remove && !delta)) { externalAction.unknown = true; return; }
    const token = identity(item);
    const previous = externalAction.intents.get(token);
    // A Shopify discount may split one identity into several lines. +/- changes
    // the group by one, while remove subtracts only this line's projected qty.
    // Keep pending per-key quantities for rapid clicks before AMP acknowledges;
    // new keys start from the latest callback snapshot after discounts rotate.
    const lineQuantity = pendingLine ? pendingLine.quantity : Number(item.quantity);
    const nextLineQuantity = remove ? 0 : Math.max(0, lineQuantity + delta);
    const quantity = (previous ? previous.quantity : groupQuantity(lastCart, token)) + nextLineQuantity - lineQuantity;
    externalAction.lines.set(String(key || item.key), { item: item, quantity: nextLineQuantity });
    externalAction.intents.set(token, { identity: token, quantity: Math.max(0, quantity) });
  }
  connectApps();
  if (doc && doc.addEventListener) {
    ['cart:updated', 'cart:change', 'ajaxCart:updated', 'cart:refresh', 'ajaxProduct:added'].forEach(name => doc.addEventListener(name, function () {
      progressConfirmation = null;
      schedule();
    }, { passive: true }));
    ['drawer:open', 'cart:open'].forEach(name => doc.addEventListener(name, schedule, { passive: true }));
    doc.addEventListener('click', function (event) {
      const button = event.target && event.target.closest && event.target.closest('#slidecarthq .quantity-selector button, #slidecarthq button.remove');
      if (button) { trackExternal(button); schedule(); }
      else {
        const discountRemove = event.target && event.target.closest && event.target.closest('#slidecarthq .footer-code button');
        if (discountRemove) trackDiscount('removed');
      }
    }, { passive: true, capture: true });
    doc.addEventListener('submit', function (event) {
      const form = event.target;
      if (form && form.matches && form.matches('#slidecarthq form.discount-box-form')) {
        const input = form.querySelector && form.querySelector('[name="discount_code"]');
        if (input && String(input.value || '').trim()) trackDiscount('applied');
      }
    }, { passive: true, capture: true });
    doc.addEventListener('visibilitychange', function () { if (!doc.hidden) { progressConfirmation = null; schedule(); } });
    doc.addEventListener('DOMContentLoaded', function () { showWelcome(); connectApps(); schedule(); }, { once: true });
  }
  if (env.addEventListener) {
    env.addEventListener('load', connectApps, { once: true });
    env.addEventListener('pagehide', function () { progressConfirmation = null; });
    env.addEventListener('pageshow', function () { progressConfirmation = null; showWelcome(); schedule(); });
    env.addEventListener('storage', function (event) {
      if (event.key === welcomeStorageKey && welcomeWasDismissed()) hideWelcome();
      if (event.key === storageKey) { progressConfirmation = null; readShared(); schedule(); }
    });
  }
  showWelcome();
  schedule();
  return { readCart: () => enqueue(get), change: change, beforeCheckout: beforeCheckout, schedule: schedule, getMutationVersion: () => requestedMutationVersion, getLastCartActionAt: () => lastCartActionAt, isManaged: isManaged, hasContext: hasContext, inspect: inspect, getProgress: getProgress };
});
